const TOKEN_ID = 'token';
const UM_URL_ID = 'userManagerUrl';
const CLIENT_ID = 'clientId';
const API_VERSION_ID = 'clientId';
const LOCATIONS_ID = 'locations';
const LOCATION_SUFFIX_ID = 'suffix';

export const JWTService = {
  // setters
  setToken: token => window.localStorage.setItem(TOKEN_ID, token),
  setUMUrl: url => window.localStorage.setItem(UM_URL_ID, url),
  setClientId: clientId => window.localStorage.setItem(CLIENT_ID, clientId),
  setAPIVersion: version => window.localStorage.setItem(API_VERSION_ID, version),
  setLocations: locations => window.localStorage.setItem(LOCATIONS_ID, locations),
  setLocationSuffix: suffix => window.localStorage.setItem(LOCATION_SUFFIX_ID, suffix),
  // getters
  getToken: () => window.localStorage.getItem(TOKEN_ID) || null,
  getUMUrl: () => window.localStorage.getItem(UM_URL_ID) || null,
  getClientId: () => window.localStorage.getItem(CLIENT_ID) || null,
  getAPIVersion: () => window.localStorage.getItem(API_VERSION_ID) || null,
  getLocations: () => window.localStorage.getItem(LOCATIONS_ID) || '[]',
  getLocationSuffix: () => window.localStorage.getItem(LOCATION_SUFFIX_ID) || '',
  // removers
  removeToken: () => window.localStorage.removeItem(TOKEN_ID),
};

export default JWTService;
